import React from "react";
const RangeComponent = React.memo(({ min, max, step, style, value, handlerChange }) => {
    const onChange = (e) => {
        handlerChange(e.target.value);
    };
    return (React.createElement("input", { type: 'range', min: min, max: max, step: step, value: value, onChange: onChange, style: style }));
});
export default RangeComponent;
